/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; //  Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function () {
    // detect product type in collection page
    if (window.location.pathname.includes('/collections')) {
        let location_param = window.location.search.substring(1).split('&');
        const collection_url = window.location.pathname.split('/');

        // Helper function to check if the parameter includes a specific value
        function hasParam(paramName) {
            return location_param.some(param => param.includes(paramName));
        }

        // Determine if gender is included in the URL
        const isGenderMen = hasParam('Men');
        const isGenderWomen = hasParam('Women');

        if (window.location.search.substring(1) != '') {
            $('.filter-form .filter-group').each(function (i, v) {
                const $group = $(v);

                if (hasParam('Footwear')) {
                    console.log('param footwear 1111');
                    if (isGenderMen && $group.hasClass('size-footwear-men-true')) {
                        $('div[class*="-true"]').hide();
                        $group.show();
                        $('.filter-model-true, .filter-collection-true, .filter-shoes-type-true').show();
                        console.log('Showing men\'s footwear');
                    } else if (isGenderWomen && $group.hasClass('size-footwear-women-true')) {
                        $('div[class*="-true"]').hide();
                        $group.show();
                        $('.filter-model-true, .filter-collection-true, .filter-shoes-type-true').show();
                        console.log('Showing women\'s footwear');
                    } else {
                        $('.filter-model-true, .filter-collection-true, .filter-shoes-type-true, .size-footwear-women-true, .size-footwear-men-true').show();
                        $('.size-apparel-women-true, .size-apparel-men-true, .size-accessories-unisex-true').hide();
                    }
                } else if (hasParam('Apparel')) {
                    if (isGenderMen && $group.hasClass('size-apparel-men-true')) {
                        $('div[class*="-true"]').hide();
                        $group.show();
                        $('.filter-model-true, .filter-collection-true, .filter-shoes-type-true').show();
                        console.log('Showing men\'s apparel');
                    } else if (isGenderWomen && $group.hasClass('size-apparel-women-true')) {
                        $('div[class*="-true"]').hide();
                        $group.show();
                        $('.filter-model-true, .filter-collection-true, .filter-shoes-type-true').show();
                        console.log('Showing women\'s apparel');
                    } else {
                        $('.size-apparel-women-true, .size-apparel-men-true').show();
                        $('.filter-model-true, .filter-collection-true, .filter-shoes-type-true, .size-footwear-women-true, .size-footwear-men-true, .size-accessories-unisex-true').hide();
                    }
                } else if (hasParam('Accessories')) {
                    $('div[class*="-true"]').hide();
                    $('.size-accessories-unisex-true').show();
                } else {
                    // Hide all groups that contain `-true` classes
                    if (collection_url.includes('apparel-accessories')) {
                        $('.size-accessories-unisex-true').show();
                    } else {
                        // $('div[class*="-true"]').hide();
                        // $('.filter-form .filter-group').show();
                    }
                    // Show the current group if it does NOT contain `-true` class
                    if (!$group.attr('class').split(' ').some(cls => cls.includes('-true'))) {
                        $group.show();
                    } else {
                        // $group.hide();
                    }
                }
            });
        } else if (window.location.search.substring(1) == '') {
            if (collection_url.includes('apparel-accessories')) {
                $('.filter-form .filter-group').show();
                $('div[class*="footwear"], .filter-model-true, .filter-collection-true, .filter-shoes-type-true').hide();
            } else {
                $('.filter-form .filter-group').show();
            }
        }
    }

    if ($("#shopify-section-popup .NewsletterPopup").length) {
        const targetElement = document.querySelector('#shopify-section-popup .NewsletterPopup')

        const observer = new MutationObserver(function (mutationsList) {
            mutationsList.forEach(function (mutation) {
                if (mutation.type === 'attributes') {
                    const newValue = mutation.target.getAttribute(mutation.attributeName);
                    if (mutation.attributeName == "aria-hidden" && newValue == "false") {
                        $(".PageOverlayPopup").addClass("is-visible")
                        $("html").addClass("no-scroll")
                    } else {
                        $(".PageOverlayPopup").removeClass("is-visible")
                        $("html").removeClass("no-scroll")
                    }
                }
            });
        });

        observer.observe(targetElement, {
            attributes: true
        });
    }

    if ($(".quick--access").length) {
        function removeClassOpened() {
            $('.quick--access').each(function () {
                var element = $(this);
                element.attr('class', function (i, c) {
                    return c.split(' ').filter(function (className) {
                        return !className.includes('opened');
                    }).join(' ');
                });
            });
        }

        $(".quick--access-toggle").click(function () {
            // removeClassOpened()
            $(".quick--access").toggleClass("opened opened--clicked")

            if (window.matchMedia('(max-width: 640px)').matches) {
                $("body").toggleClass("overflow-hidden")
                if ($(".quick--access-content_wrapper:not(.wrapper-cart) .header--1-logo").length == 0) {
                    $(".header--1-wrapper > .header--1-logo").clone().prependTo(".quick--access-content_wrapper:not(.wrapper-cart)");
                }

                if ($(".sticky--atc-qa").length) {
                    let sticky_atc_ = $(".sticky--atc-qa").outerHeight() + 30

                    $(".quick--access-content_wrapper:not(.wrapper-cart)").css("padding-bottom", sticky_atc_ + 'px')

                    if ($(".sticky--atc-qa").hasClass("opened")) {
                        setTimeout(() => {
                            $(".sticky--atc-qa").toggleClass("opened")
                        }, 1000);
                    } else {
                        $(".sticky--atc-qa").toggleClass("opened")
                    }
                }
            }
        })

        $(".quick--access-toggle-notif, .notification--close").click(function () {
            // removeClassOpened()
            $(".quick--access").toggleClass("opened-cart opened--clicked")
            if ($(".wrapper-cart .newest--product-list.slick-slider").length < 1) {
                setTimeout(() => {
                    $('.wrapper-cart .newest--product-list').slick({
                        dots: false,
                        arrows: false,
                        infinite: false,
                        slidesToShow: 3.1,
                        slidesToScroll: 1,
                        responsive: [{
                            breakpoint: 641,
                            settings: {
                                slidesToShow: 2.1
                            }
                        }]
                    })

                    $('.wrapper-cart .newest--product-list .color-swatch-pi--list').slick('unslick');
                    $(`.wrapper-cart .newest--product-list .color-swatch-pi--list`).slick({
                        dots: false,
                        arrows: false,
                        infinite: true,
                        slidesToShow: 4,
                        slidesToScroll: 1
                    })
                }, 800);
            }

            if (window.matchMedia('(max-width: 640px)').matches) {
                $("body").toggleClass("overflow-hidden")
                if ($(".quick--access-content_wrapper.wrapper-cart .header--1-logo").length == 0) {
                    $(".header--1-wrapper > .header--1-logo").clone().prependTo(".quick--access-content_wrapper.wrapper-cart");
                }

                if ($(".sticky--atc-qa").length) {
                    let sticky_atc_ = $(".sticky--atc-qa").outerHeight() + 30

                    $(".quick--access-content_wrapper.wrapper-cart").css("padding-bottom", sticky_atc_ + 'px')
                    if ($(".sticky--atc-qa").hasClass("opened-cart")) {
                        setTimeout(() => {
                            $(".sticky--atc-qa").toggleClass("opened-cart")
                        }, 1000);
                    } else {
                        $(".sticky--atc-qa").toggleClass("opened-cart")
                    }
                }
            }
        })

        $(".quick--access-search").click(function () {
            // removeClassOpened()
            $(".quick--access").toggleClass("opened-search opened--clicked")
            if ($(".wrapper-search .newest--product-list.slick-slider").length < 1) {
                setTimeout(() => {
                    $('.wrapper-search .newest--product-list').slick({
                        dots: false,
                        arrows: false,
                        infinite: false,
                        slidesToShow: 3.1,
                        slidesToScroll: 1,
                        responsive: [{
                            breakpoint: 641,
                            settings: {
                                slidesToShow: 2.1,
                            }
                        }]
                    })

                    $('.wrapper-search .newest--product-list .color-swatch-pi--list').slick('unslick');
                    $(`.wrapper-search .newest--product-list .color-swatch-pi--list`).slick({
                        dots: false,
                        arrows: false,
                        infinite: true,
                        slidesToShow: 4,
                        slidesToScroll: 1
                    })
                }, 800);
            }
        })

        function formatNumber(number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }

        let typingTimer;
        $('#search--revamp [name=q]').on('input', function () {
            clearTimeout(typingTimer);
            $("#search--revamp .close--icon").hide()
            if ($(this).val() != "") {
                $("#search--revamp .close--icon").show()
            }

            typingTimer = setTimeout(function () {
                let q = $("#search--revamp [name=q]").val().trim()

                if (q !== "") {
                    $.ajax({
                        type: 'GET',
                        url: `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor`,
                        success: function (response) {
                            let product_count = 0;
                            if (response.resources && response.resources.results.products) {
                                let products = response.resources.results.products;

                                product_count = products.length
                                if (products.length > 0) {
                                    $(".newest--product-wrapper").hide()
                                    $(".newest--product-searched").show()
                                    let limit = window.matchMedia('(min-width: 641px)').matches ? 9 : 8;

                                    // let product_element = ``;
                                    // products.slice(0, limit).forEach(product => {
                                    //     let price = formatNumber(product.price * 1)
                                    //     let product_item_info = ''
                                    //     let product_tags = product.tags

                                    //     product_tags.forEach(function(tag){
                                    //         if(tag.includes("product-info__")){
                                    //             product_item_info = tag.replace("product-info__", "")
                                    //         }
                                    //     })
                                    let product_element = ``;
                                        products.slice(0, limit).forEach(product => {
                                        let price = formatNumber(product.price * 1);
                                        let product_item_info = '';
                                        let product_tags = product.tags;

                                        // Ambil tag yang diawali dengan "product-info__"
                                        let info_tags = product_tags.filter(tag => tag.includes("product-info__"));

                                        // Sort berdasarkan angka setelah "product-info__" (misal 1_, 2_, 3_)
                                        info_tags.sort((a, b) => {
                                            let numA = parseInt(a.match(/product-info__([0-9]+)_/)?.[1] || 999);
                                            let numB = parseInt(b.match(/product-info__([0-9]+)_/)?.[1] || 999);
                                            return numA - numB;
                                        });

                                        // Ambil maksimal 3 tag
                                        info_tags.slice(0, 3).forEach(tag => {
                                            // Bersihkan prefix, hapus "product-info__1_", "product-info__2_", dst.
                                            let clean_text = tag
                                            .replace(/product-info__\d+_/, '') // hilangkan prefix dengan angka
                                            .replace('product-info__', '');    // fallback kalau ga ada angka

                                            product_item_info += (product_item_info ? ', ' : '') + clean_text;
                                        });

                                        product_element += `
                                            <div class="newest--product-item Grid__Cell quick-add-for-0 1/2--phone 1/2--tablet-and-up 1/3--desk">
                                                <div class="ProductItem">
                                                <div class="ProductItem__Wrapper">
                                                    <a href="${product.url}" class="quick-view--item ProductItem__ImageWrapper ProductItem__ImageWrapper--withAlternateImage">
                                                    <img src="${product.image}">
                                                    </a>
                                                    <div class="ProductItem__Info ProductItem__Info--left">
                                                    <div class="color-swatch-pi">
                                                    </div>
                                                    <h2 class="ProductItem__Title Heading">
                                                        <a href="${product.url}" class="quick-view--item" data-product="${product.handle}" data-collection="performance-running">${product.title}</a>
                                                    </h2>
                                                    <div class="product--info">${product_item_info}</div>
                                                    <div class="ProductItem__PriceList   Heading">
                                                        <span class="ProductItem__Price Price Text--subdued">Rp ${price}</span>
                                                    </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                        `;
                                    });

                                    $(".searched--product-list").html(product_element)
                                    $(".searched--product-more").hide()
                                    if (products.length > 9) {
                                        $(".searched--product-more a").attr("href", `/search?q=${q}&type=product`)
                                        $(".searched--product-more").show()
                                    }
                                }
                            }

                            if (product_count < 1) {
                                $(".newest--product-wrapper").show()
                                $(".newest--product-searched").hide()
                            }
                        },
                        error: function (xhr, status, error) {
                            console.error('Error fetching suggestions:', status, error);
                        },
                        complete: function () {
                            ajaxLoaded = false; // Reset ajaxLoaded regardless of success or failure
                        }
                    });
                } else {
                    $(".newest--product-wrapper").show()
                    $(".newest--product-searched").hide()
                }
            }, 1000);
        })

        $('#search--revamp .close--icon').on('click', function () {
            $('#search--revamp [name=q]').val("")
            $(".newest--product-wrapper").show()
            $(".newest--product-searched").hide()
            $("#search--revamp .close--icon").hide()
        })

        $("#search--revamp").submit(function (e) {
            e.preventDefault()
        })

        // const targetElement = document.querySelector('.quick--access')
        // const observer = new MutationObserver(function(mutationsList) {
        //   mutationsList.forEach(function(mutation) {
        //     if (mutation.target.classList.contains('opened--clicked')) {
        //       setTimeout(() => {
        //         $(".quick--access-content_wrapper").css("z-index", 2)
        //       }, 800);
        //     }
        //     else{
        //       $(".quick--access-content_wrapper").css("z-index", 1)
        //     }
        //   });
        // });

        // observer.observe(targetElement, { attributes: true, attributeFilter: ['class'] });
    }

    if ($('.category--banner').length) {
        let arrow = `<svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_37_124)">
          <path d="M21.7156 30.5041C28.1515 30.5041 34.5891 30.5041 41.0251 30.5041C41.5658 30.5041 42.1083 30.5041 42.649 30.4975C43.9502 30.4825 44.7089 29.8269 44.7206 28.5241C44.7322 27.2296 44.0117 26.5241 42.6973 26.5091C41.1815 26.4908 39.6657 26.4992 38.1515 26.4975C33.1715 26.4975 28.1931 26.4975 23.2131 26.4975C22.6956 26.4975 22.1781 26.4975 21.6607 26.4975C21.5875 26.3694 21.5142 26.2396 21.4394 26.1115C22.8537 24.7354 24.3013 23.3927 25.6723 21.975C26.842 20.7654 26.7023 19.0865 25.3112 18.6606C24.6008 18.4426 23.4144 18.6855 22.8753 19.1863C20.2181 21.6489 17.6823 24.2462 15.1515 26.8436C14.0167 28.0066 14.065 29.0749 15.2114 30.2346C17.6823 32.7388 20.1848 35.2113 22.664 37.7071C23.6291 38.6789 24.674 39.0249 25.8071 38.0549C26.8171 37.1897 26.7089 36.0333 25.4776 34.8286C24.1365 33.5191 22.7222 32.2845 21.3395 31.0166C21.4643 30.8469 21.5891 30.6755 21.7139 30.5058L21.7156 30.5041Z" fill="white"/>
          <circle cx="28.5" cy="28.5" r="28" transform="matrix(-1 0 0 1 57 0)" stroke="white"/>
      </g>
      <defs>
          <clipPath id="clip0_37_124">
              <rect width="57" height="57" fill="white" transform="matrix(-1 0 0 1 57 0)"/>
          </clipPath>
      </defs>
    </svg>`;
        $('.category--banner-list').slick({
            dots: false,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 4000,
            prevArrow: $('.category--banner-nav .slick-prev'),
            nextArrow: $('.category--banner-nav .slick-next'),
            responsive: [{
                breakpoint: 641,
                settings: {
                    slidesToShow: 1,
                    dots: true
                }
            }]
        })
    }

    if ($(".pagination--collection").length) {
        if (window.matchMedia('(min-width: 641px)').matches) {
            $(".collection-inner-custom").after($(".pagination--collection"))
        }
    }

    if ($("#notify-me--button").length) {
        $("#notify-me--button, .popup--all[data-popup='notify-me'] .popup--all-close").click(function (e) {
            e.preventDefault();
            let get_current = JSON.parse(localStorage.getItem('current_variant'))

            $(".popup--all[data-popup='notify-me']").toggleClass("active")
            $(".PageOverlay").toggleClass("is-visible")
            $("body").toggleClass("notify--me-active no-scroll")
            $(".popup--all-product_name").html(get_current.product_name)
        })

        $(document).on("click", ".notify--me-active .PageOverlay.is-visible", function () {
            $(".popup--all[data-popup='notify-me']").removeClass("active")
            $("body").toggleClass("notify--me-active no-scroll")
        })

        function objectToFormData(obj) {
            const formData = new FormData();
            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    formData.append(key, obj[key]);
                }
            }
            return formData;
        }

        $(document).on("submit", "#notify--me-form", function (e) {
            e.preventDefault();
            let get_current = JSON.parse(localStorage.getItem('current_variant'))

            var url = 'https://notify-me.shopify-plugin.devbdd.com/index.php/config/simpanCustomer';
            let data = {
                url_shopify: Shopify.shop,
                nama: $(this).find("input[name='nama']").val(),
                email: $(this).find("input[name='email']").val(),
                no_telp: $(this).find("input[name='no_telp']").val(),
                product_name: get_current.product_name,
                product_sku: get_current.product_sku,
                variant_id: get_current.variant_id,
            }

            console.log(data)

            const formData = objectToFormData(data);
            $.ajax({
                type: "POST",
                url: url,
                data: formData,
                dataType: "text",
                cache: false,
                contentType: false,
                crossDomain: true,
                processData: false,
                beforeSend: function () {
                    $("[data-popup='notify-me']").find(".popup--all-button").text('Pleas Wait...')
                    $("[data-popup='notify-me']").find(".popup--all-button").attr('disabled', 'disabled')
                },
                success: function (response) {
                    $("[data-popup='notify-me']").find(".popup--all-button").text('Notify me')
                    $("[data-popup='notify-me']").find(".popup--all-button").attr('disabled', false);

                    console.log(response)

                    if (response == 200) {
                        $("[data-popup='notify-me']").find(".popup--all-response").html(`
              <span class="success-message">Your request has been submitted</span>  
            `)

                        setTimeout(() => {
                            $("[data-popup='notify-me']").find(".popup--all-close").trigger("click")
                            $("[data-popup='notify-me']").find(".popup--all-response").html("")
                            $("[data-popup='notify-me']").find("input").val("")
                        }, 2000);
                    } else {
                        alert("Something wrong, Please refresh page")
                    }
                },
                error: function (response) {
                    alert('Something wrong, Please refresh page.')
                }
            });
        })
    }

    if (window.matchMedia('(max-width: 640px)').matches) {
        if ($('.step--on-list').length) {
            $('.step--on-list').slick({
                dots: false,
                arrows: false,
                infinite: false,
                slidesToShow: 1.5,
                slidesToScroll: 1
            })
        }

        if ($(".gender--filter").length) {
            $(".top--filter-gender").clone().appendTo(".gender--filter");
        }

        if ($(".Product__Image").length) {
            $(".Product__Image .Product__Image--list").slick({
                arrows: false,
                dots: true,
                infinite: true,
                autoplay: true,
                autoplaySpeed: 2000
            })

            $(".ProductMeta__Title").after($(".ProductMeta__Description"))

            // $(".Product__Image .Product__Image--list-thumb").slick({
            //   arrows: false,
            //   dots: false,
            //   asNavFor: '.Product__Image--list',
            //   slidesToShow: 4.5,
            //   slidesToScroll: 1,
            //   infinite: false
            // })

            // $('.Product__Image--list-thumb').on('click', '.slick-slide', function(e) {
            //   var $currTarget = $(e.currentTarget),
            //     index = $currTarget.data('slick-index'),
            //     slickObj = $('.Product__Image--list').slick('getSlick');

            //   slickObj.slickGoTo(index);
            // });

            $(".Product__Image").append($(".list-variant"))
        }

        if ($(".product--feature-list").length) {
            $(".product--feature-list").slick({
                arrows: false,
                dots: false,
                slidesToShow: 1.5,
                slidesToScroll: 1,
                infinite: false
            })
        }

        $(".toggle--filter, .close--filter").click(function () {
            $(".kolom-filter").toggleClass("active")
            $("body").toggleClass("overflow-hidden")
            $(".view--result").toggleClass("active")
            if ($(".kolom-filter .header--1-logo").length == 0) {
                $(".header--1-wrapper > .header--1-logo").clone().prependTo(".kolom-filter .inner-filter");
            }

            let inner_filter = parseInt($(".inner-filter").css("padding-top").replace('px', ''));
            let view_result = $(".view--result").outerHeight()

            let header_filter = inner_filter + $(".filter-custom .header--1-logo").outerHeight() + view_result
            var window_height = jQuery(window).height();
            var max_height_filter = window_height - header_filter;

            $(".inner-filter--app").css({
                'max-height': max_height_filter + 'px'
            });
        })
    }

    // $(".ProductForm__Variants input").on("change", function () {
    //   var intatc = setInterval(() => {
    //     var vall = $(".ProductForm__AddToCart").html();
    //     if (vall != "Sold Out") {
    //       $(".ProductForm__AddToCart").html("Add To Cart")
    //     }
    //     else {
    //       clearInterval(intatc)
    //     }

    //     if ($(".ProductForm__AddToCart").html() == "Select") {
    //       clearInterval(intatc)
    //     }

    //   }, 0);
    // })

    if ($('.ProductForm__AddToCart').length) {
        $('.ProductForm__AddToCart').click(function () {
            // $(this).removeClass('Button--primary');
            // $(this).addClass('Button--primary-gray');
        });
    }

    // var intfloating = setInterval(() => {
    //   jQuery.getJSON('/cart.js', function (cart) {
    //     var item = cart.items;
    //     if (item.length) {
    //       $(".floating-order").addClass("floating-active");
    //     }
    //     else {
    //       $(".floating-order").removeClass("floating-active");
    //     }
    //   });
    // }, 1000);

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    $(document).on("submit", "[action='/cart']", function (e) {
        e.preventDefault();
        // var produkna = "";
        // jQuery.ajaxSetup({
        //   async: false
        // });
        // jQuery.getJSON('/cart.js', function (cart) {
        //   $("form[action='/cart'] .Cart__Checkout").html("Please Wait...").attr("disabled")
        //   var item = cart.items;
        //   for (let index = 0; index < item.length; index++) {
        //     var variantOption = item[index].variant_options ?? ""
        //     var product_title = item[index].product_title
        //     var gender = ""
        //     jQuery.getJSON(`/products/${item[index].handle}.js`, function(product) {
        //       product['tags'].forEach(function(pr){
        //         if(pr.includes("gender-")){
        //           gender = pr.split("-")[1];
        //           gender = gender.charAt(0).toUpperCase() + gender.slice(1)
        //         }
        //       })
        //     })

        //     var product_d = `- ${product_title} ${gender} - ${item[index].variant_options[1]} (quantity: ${item[index].quantity})`
        //     produkna += `${product_d}%0A`;
        //   }
        //   produkna = capitalizeFirstLetter(produkna);
        //   // console.log(produkna);
        //   var pesan = `https://api.whatsapp.com/send?phone=6282289999707&text=My product selection(s): %0A${produkna}%0APlease check for product availability`;
        //   pesan = pesan.replace(/ /g, "%20");

        //   window.location.assign(pesan);
        //   return false;
        // });

        localStorage.setItem("back_to_product", location.href)
        location.href = `https://${Shopify.shop}/pages/checkout`
        return false;
    })

    if ($('.discover-container').length) {
        $('.discover-container').owlCarousel({
            items: 4,
            margin: 10,
            loop: true,
            responsive: {
                0: {
                    items: 2
                },
                640: {
                    items: 2
                },
                1140: {
                    items: 4
                }
            }
        })
    }

    var quick_order = $('.quick-add')
    for (let i = 0; i < quick_order.length; i++) {
        $('.quick-open-for-' + i).click(function (event) {
            $('.quick-open-for-' + i + ' .quick-open').hide();
            $('.quick-open-for-' + i + ' .form-submit').show();
        })
        document.querySelectorAll(".quick-open-for-" + i + " .ColorSwatch__Radio").forEach(item => {
            item.addEventListener("change", () => {
                $('.add-to-cart-for-' + i).attr('data-var_id', item.value)
                $('.add-to-cart-for-' + i).attr('data-add-to-cart', item.value)
            })
        })
        $('.add-to-cart-for-' + i).click(function () {
            var swatchId = $(this).attr('data-var_id');
            swatchAddItemToCart(swatchId, 1);
        })

        function swatchAddItemToCart(variantId, Qty) {
            data = {
                "id": variantId,
                "quantity": Qty
            }
            jQuery.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                dataType: 'json',
                success: function (data) {
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                        bubbles: true
                    }));
                    setTimeout(() => {
                        $('a[data-drawer-id="sidebar-cart"]').trigger('click');
                        $('#sidebar-cart').attr('aria-hidden', false);
                        $('#sidebar-cart').attr('tabindex', "-1");
                        $('.PageOverlay').addClass('is-visible')
                    }, 500);
                    setTimeout(() => {
                        $('button[data-drawer-id="sidebar-cart"]').trigger('click');
                        $('#sidebar-cart').attr('aria-hidden', true);
                        $('#sidebar-cart').removeAttr('tabindex')
                        $('.PageOverlay').removeClass('is-visible')
                    }, 3000);
                }
            });
        }
    }


    // var cek_variant_qty = $('select[name=id]').find(":selected").attr('disabled');
    // console.log(cek_variant_qty);
    // if (cek_variant_qty !== undefined) {
    //   $('#bdd-notify').css('display', 'block');
    // }
    number_format = function (number, decimals, dec_point, thousands_sep) {
        number = number.toFixed(decimals);

        var nstr = number.toString();
        nstr += "";
        x = nstr.split(".");
        x1 = x[0];
        x2 = x.length > 1 ? dec_point + x[1] : "";
        var rgx = /(\d+)(\d{3})/;

        while (rgx.test(x1)) x1 = x1.replace(rgx, "$1" + thousands_sep + "$2");

        return x1 + x2;
    };

    var heighestElement = function (passname) {
        var maxHeight = 0;
        jQuery(passname).each(function () {
            if (jQuery(this).height() > maxHeight) {
                maxHeight = jQuery(this).height();
            }
            // console.log(maxHeight)
        });

        jQuery(passname).height(maxHeight);
        // console.log(maxHeight)
    }

    let lastScroll = 0;
    let headerHeight = $('#shopify-section-header-rvmp1').outerHeight();
    window.addEventListener("scroll", () => {
        const currentScroll = window.pageYOffset;
        var window_height = jQuery(window).height();

        // console.log(currentScroll);
        if (currentScroll < 200) {
            jQuery('.filter-custom').addClass('mh-unset');
        } else {
            jQuery('.filter-custom').removeClass('mh-unset');
        }

        if (currentScroll > lastScroll) {
            if (currentScroll > headerHeight) {
                $('.header--1-navigation').addClass('down')
                $('.header--1-navigation').removeClass('up')

                if ($('.custom-filter-sec').length > 0) {
                    var heightTambah = jQuery('.title-and-sort').outerHeight();
                    var maxHeightna = window_height - heightTambah;
                    jQuery('.filter-custom').css('top', heightTambah + 'px');
                    jQuery('.filter-custom').css('max-height', maxHeightna + 'px');
                }
            }
        } else if (currentScroll < lastScroll) {
            $('.header--1-navigation').removeClass('down')
            $('.header--1-navigation').addClass('up')

            if ($('.custom-filter-sec').length > 0) {
                var heightTambah = jQuery('.header--1-navigation').outerHeight();
                var maxHeightna = window_height - heightTambah;
                jQuery('.filter-custom').css('top', heightTambah + 'px');
                jQuery('.filter-custom').css('max-height', maxHeightna + 'px');
            }
        }

        if (currentScroll < 120) {
            $('.header--1-navigation').removeClass('up')
        }

        lastScroll = currentScroll;
    })

    $('div[data-block-handle="platmart-product-colors"]').prependTo('.color-swatches')

    if ($('.slider-collection').length) {
        $('.slider-collection').owlCarousel({
            loop: true,
            responsiveClass: true,
            nav: true,
            navText: [
                "<div class='nav-btn prev-slide'></div>",
                "<div class='nav-btn next-slide'></div>",
            ],
            margin: 0,
            autoplayTimeout: 4000,
            smartSpeed: 400,
            center: true,
            responsive: {
                0: {
                    items: 1,
                },
                600: {
                    items: 3
                },
                1200: {
                    items: 3
                }
            }
        });
    }

    // if ($('.slider-cl').length > 0) {
    //   $('.slider-cl').flickity({
    //     pageDots: false,
    //     wrapAround: true,
    //     cellAlign: 'center',
    //     adaptiveHeight: true,
    //     imagesLoaded: true
    //   });

    //   var intCl = setInterval(() => {
    //     if ($('.slider-cl').outerHeight() > 0) {
    //       $('.slider-cl').prepend(`
    //         <style>
    //           .item-swipe img{
    //             max-width: 80%;
    //             transition: .5s ease;
    //           }
    //         </style>
    //       `);
    //       heighestElement('.slider-cl .item-swipe');

    //       // jQuery('.slider-cl .next').click(function(){
    //       //   jQuery('.item-swipe .innerItem').removeClass('text-left')
    //       //   jQuery('.item-swipe.is-selected .innerItem').addClass('text-left')
    //       // })

    //       // jQuery('.slider-cl .previous').click(function(){
    //       //   jQuery('.item-swipe .innerItem').removeClass('text-right')
    //       //   jQuery('.item-swipe.is-selected .innerItem').addClass('text-right')
    //       // })

    //       clearInterval(intCl);
    //     }
    //   }, 500);

    //   var intLastItem = setInterval(() => {
    //     if ($('.item-swipe:last-child').hasClass("is-selected")) {
    //       $('.item-swipe:first-child .innerItem').addClass('text-left')
    //     }
    //     else {
    //       $('.item-swipe:first-child .innerItem').removeClass('text-left')
    //     }
    //   }, 1);
    // }

    if ($('.custom-filter-sec').length > 0) {
        jQuery(".filter-group-display").hide();
        jQuery(".filter-group[open] .filter-group-display").show();
        jQuery(".filter-group-summary").click(function () {
            var parentFilter = jQuery(this).parent();
            if (parentFilter.attr("open")) {
                jQuery(this).parent().find(".filter-group-display").hide(400);
                parentFilter.removeAttr("open");
            } else {
                jQuery(this).parent().find(".filter-group-display").show(400);
                parentFilter.attr("open", "");
            }
        });

        jQuery('.filter-group-display__list-item input[type=checkbox]').change(function () {
            var action = jQuery(this).attr('click-action')
            console.log(jQuery(this).val())
            jQuery('[click-action=' + action + ']input:checkbox').not(this).prop('checked', false);
            jQuery(".filter-form").submit();
        })

        jQuery('.item-active').click(function () {
            var action = jQuery(this).attr('click-action').replace(' ', '_')
            console.log(action)
            jQuery('.filter-group-display__list-item input[type=checkbox][data-value=' + action + ']').click();
        })

        jQuery('.sort-mobile .filter-group-display__list-item input[type=radio]').change(function () {
            var action = jQuery(this).val()
            const urlSearchParams = new URLSearchParams(
                window.location.search
            );

            urlSearchParams.set('sort_by', action);
            window.location = `?${urlSearchParams}`;
        })
    }
    // if (jQuery(".flat-slider").length > 0) {
    //   let maxRange = parseInt(
    //     jQuery(".filter-group-display__price-range-to input").attr("max")
    //   );

    //   let currentMin = jQuery(
    //     ".filter-group-display__price-range-from input"
    //   ).val();
    //   let currentMax = jQuery(
    //     ".filter-group-display__price-range-to input"
    //   ).val();

    //   // console.log(maxRange, currentMin, currentMax)

    //   // console.log(number_format(maxRange, 0, ',', '.') + ' - ' + currentMin + ' - ' +  currentMax)

    //   jQuery("#flat-slider").slider({
    //     orientation: "horizontal",
    //     range: true,
    //     animate: true,
    //     min: 0,
    //     max: Number(maxRange),
    //     values: [Number(currentMin), Number(currentMax)],
    //     slide: function (event, ui) {
    //       if (ui.values[1] - ui.values[0] < 1) {
    //         return false;
    //       }

    //       // console.log(ui.values[0] + ' - ' + ui.values[1])

    //       jQuery(".filter-group-display__price-range-from input").val(
    //         ui.values[0]
    //       );
    //       jQuery(".filter-group-display__price-range-to input").val(
    //         ui.values[1]
    //       );

    //       var minFormat = number_format(ui.values[0], 0, ",", ".");
    //       var maxFormat = number_format(ui.values[1], 0, ",", ".");

    //       jQuery(".flex-price-range .min-price").html("IDR " + minFormat);
    //       jQuery(".flex-price-range .max-price").html("IDR " + maxFormat);
    //     },
    //   });
    // }

    if (jQuery("#SortBy").length > 0) {
        document
            .querySelector("#SortBy")
            .addEventListener("change", function () {
                const urlSearchParams = new URLSearchParams(
                    window.location.search
                );

                urlSearchParams.set(this.name, this.value);

                window.location = `?${urlSearchParams}`;
            });
    }

    jQuery('.filter-trig-mobile, .close-filter').click(function () {
        jQuery('.kolom-filter').toggleClass('active');
        jQuery('body').toggleClass('overflow-none');
    })
    // Get the modal
    var modal = document.getElementById("modal-wishlist");
    var modal2 = document.getElementById("modal-wishlist2");

    // Get the button that opens the modal
    var btn = document.getElementById("popup-wishlist");
    var btn2 = document.getElementById("popup-wishlist2");

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("popup-close")[0];
    var span2 = document.getElementsByClassName("popup-close2")[0];

    // When the user clicks the button, open the modal 
    // btn.onclick = function () {
    //   modal.style.display = "block";
    //   $('body').css('overflow', 'hidden');
    //   $('#shopify-section-header').addClass('shopify-section-header-overlay')
    // }
    // btn2.onclick = function () {
    //   modal2.style.display = "block";
    //   $('body').css('overflow', 'hidden');
    //   $('#shopify-section-header').addClass('shopify-section-header-overlay')
    // }

    // When the user clicks on <span> (x), close the modal
    // span.onclick = function () {
    //   modal.style.display = "none";
    //   $('body').css('overflow', 'auto');
    //   $('#shopify-section-header').removeClass('shopify-section-header-overlay')

    // }
    // span2.onclick = function () {
    //   modal2.style.display = "none";
    //   $('body').css('overflow', 'auto');
    //   $('#shopify-section-header').removeClass('shopify-section-header-overlay')
    // }
    // function footer accordion
    var acc = document.getElementsByClassName("footer-accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function () {
            this.classList.toggle("footer-active");
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        });
    }
    // announcement bar slider

    if ($('.announcement-slick').length) {
        $('.announcement-slick').owlCarousel({
            items: 1,
            nav: true,
            loop: true,
            navText: [
                "<div class='nav-btn prev-slide'><i class='fa fa-arrow-left fa-lg'></i></div>",
                "<div class='nav-btn next-slide'><i class='fa fa-arrow-right fa-lg'></i></div>",
            ],
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: false,
            dots: false
        })
    }

    var acc = document.getElementsByClassName("filter-button");
    var i;

    // $(document).on("click", ".filter-button", function(){
    //   $(this).toggleClass("filter-active");
    //   let panel = $(this).next()
    //   if (panel.style.maxHeight) {
    //     panel.style.maxHeight = null;
    //   } else {
    //     panel.style.maxHeight = "210" + "px";
    //   }
    // })

    // for (i = 0; i < acc.length; i++) {
    //   acc[i].addEventListener("click", function () {
    //     this.classList.toggle("filter-active");
    //     var panel = this.nextElementSibling;
    // if (panel.style.maxHeight) {
    //   panel.style.maxHeight = null;
    // } else {
    //   panel.style.maxHeight = "210" + "px";
    // }
    //   });
    // }

    if ($(".highlight-product-wrapper").length) {
        $('.highlight-product-wrapper').owlCarousel({
            items: 4,
            margin: 15,
            nav: true,
            loop: true,
            navText: [
                "<div class='nav-btn prev-slide'><i class='fa fa-chevron-left fa-lg'></i></div>",
                "<div class='nav-btn next-slide'><i class='fa fa-chevron-right fa-lg'></i></div>",
            ],
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: false,
            dots: false,
            responsive: {
                0: {
                    items: 2
                },
                600: {
                    items: 2
                },
                1000: {
                    items: 4
                }
            }
        })
    }

    /************************** button "add to cart" collection pages **************************/

    // $('.ad_to_cart_coll').click(function () {
    //   var ID = $(this).attr("data-var_id");
    //   addItemToCart(ID, 1);    // paste your id product number
    //   $('.cart_dr').trigger("click");
    //   // alert("Added to cart");
    // });


    // function addItemToCart(variant_id, qty) {
    //   data = {
    //     "id": variant_id,
    //     "quantity": qty
    //   }
    //   jQuery.ajax({
    //     type: 'POST',
    //     url: '/cart/add.js',
    //     data: data,
    //     dataType: 'json',
    //     success: function () {

    //       document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    //         bubbles: true
    //       }));

    //       $('#sidebar-cart').attr('aria-hidden', 'false');
    //       $('.PageOverlay').addClass('is-visible');
    //       $('#sidebar-cart .Drawer__Close').click(function () {
    //         $('#sidebar-cart').attr('aria-hidden', 'true');
    //         $('.PageOverlay').removeClass('is-visible');
    //       })

    //     }

    //   });

    // }

    // document.querySelectorAll(".ColorSwatch__Radio-js").forEach(item => {
    //   item.addEventListener("change", () => {
    //     $('.swatch--add-to-cart').attr('data-var_id', item.value)
    //     $('.swatch--add-to-cart').attr('data-add-to-cart', item.value)
    //   })
    // })

    // $('.swatch--add-to-cart').click(function () {
    //   var swatch_id = $(this).attr("data-var_id");
    //   swatchAddItemToCart(swatch_id, 1);    // paste your id product number
    //   $('.cart_dr').trigger("click");
    //   // alert("Added to cart");
    // });

    // function swatchAddItemToCart(variant_id, qty) {
    //   data = {
    //     "id": variant_id,
    //     "quantity": qty
    //   }
    //   jQuery.ajax({
    //     type: 'POST',
    //     url: '/cart/add.js',
    //     data: data,
    //     dataType: 'json',
    //     success: function () {

    //       document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    //         bubbles: true
    //       }));

    //       $('#sidebar-cart').attr('aria-hidden', 'false');
    //       $('.PageOverlay').addClass('is-visible');
    //       $('#sidebar-cart .Drawer__Close').click(function () {
    //         $('#sidebar-cart').attr('aria-hidden', 'true');
    //         $('.PageOverlay').removeClass('is-visible');
    //       })

    //     }

    //   });

    // }

    $(document).on("click", ".quick-view--item", function (e) {
        // e.preventDefault();
        let product_handle = $(this).attr("data-product")
        let collection_handle = $(this).attr("data-collection")

        sessionStorage.setItem('scrollElement', product_handle);

        if (collection_handle != "") {
            sessionStorage.setItem('collectionElement', collection_handle);
        }
    })

    $(".backto-collection").click(function () {
        // history.back();
        var current_link = localStorage.getItem("search_current_collectoin")
        var link = $(".backto-collection").attr("href")
        if (current_link != "") {
            if (!location.href.includes("collections")) {
                var arrLink = location.href.split("products")
                link = `${arrLink[0]}collections/${current_link}`
                localStorage.removeItem('search_current_collectoin')

                let sessElement = sessionStorage.getItem('scrollElement');
                if (sessElement !== null) {
                    sessionStorage.removeItem('scrollElement');
                }
            }
        }

        location.href = link
        return false;
    })

    var selection = document.querySelector('#SortBy') !== null;
    if (selection) {
        document.querySelector('#SortBy').addEventListener('change', function () {
            const urlSearchParams = new URLSearchParams(window.location.search);

            urlSearchParams.set(this.name, this.value);

            window.location = `?${urlSearchParams}`;
        });
    }

    if ($("[recommendation-settings]").length) {
        var settingsArray = [];
        $("[recommendation-settings]").each(function () {
            var settings = JSON.parse($(this).attr("recommendation-settings"));
            settingsArray.push(settings);
        });

        /*
            function getSetting(setting) {
            return new Promise((resolve, reject) => {
                // Simulate an asynchronous operation (e.g., AJAX call)
                setTimeout(() => {
                resolve(setting);
                }, 2000);
            });
            }

            async function processSettings() {
            for (const setting of settingsArray) {
                try {
                const result = await getSetting(setting);
                let settings = result

                let product_name = settings.product_name
                let sameGender = settings.sameGender
                let colorProduct = settings.colorProduct
                let productCurrentUrl = location.href.split("products")[0] ?? ""
                let productHandle = settings.productHandle
                
                let data_current = {
                    product_title: product_name,
                    gender: sameGender,
                    different_gender: "",
                    only_color: true,
                    color: colorProduct,
                    shop: Shopify.shop
                };
                
                $.ajax({
                    type: "POST",
                    url: "https://on-running.devbdd.com/config/getProductSame_v2",
                    data: data_current,
                    crossDomain: true,
                    success: function(response) {
                    var data = JSON.parse(response);
                    productHandle = settings.productHandle

                    console.log(productHandle)
                
                    $(`.color-swatch-pi--list[data-product="${productHandle}"]`).html("").removeClass("loading")
                    if (data != null) {
                        var data_same = data.data_same;

                        data_same.forEach(function(el, index) {
                        var active = ""
                        var link = `${productCurrentUrl}products/${el.handle}`

                        $(`.color-swatch-pi--list[data-product="${productHandle}"]`).append(
                            `
                            <div class="color-swatch-item ${active}">
                            <a href="${link}" class="result-swatch-item">
                                <div class="swatch-img">
                                <img src="${el.image}">  
                                </div>
                            </a>  
                            </div>
                            `
                        )
                        })

                        $(`.color-swatch-pi--list[data-product="${productHandle}"]`).slick({
                        dots: false,
                        arrows: false,
                        infinite: true,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        autoplay: true,
                        autoplaySpeed: 2000,
                        })
                    }
                    },
                    error: function(err) {
                    console.log(err)
                    }
                });
                } catch (error) {
                console.error('Error fetching data from', setting.url, error);
                }
            }
            }

            processSettings()
        */

        function sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }

        async function callApi(product, retryCount = 0) {
            const maxRetries = 15; // Batas maksimal percobaan
            const retryDelay = 1500; // Delay 1 detik (1000 ms)

            const product_name = product.product_name;
            const sameGender = product.sameGender;
            const colorProduct = product.colorProduct;
            const productCurrentUrl = location.href.split("products")[0] ?? "";
            const productHandle = product.productHandle;

            const data_current = {
                product_title: product_name,
                gender: sameGender,
                different_gender: "",
                handle: productHandle,
                color: colorProduct,
                shop: Shopify.shop
            };

            const $colorSwatchList = $(`.color-swatch-pi--list[data-product="${productHandle}"]`);
            try {
                const response = await $.ajax({
                    type: "POST",
                    url: "https://on-running.devbdd.com/config/getProductSame_v2",
                    data: data_current,
                    crossDomain: true
                });
              
                const data = JSON.parse(response);
                // console.log(product_name + ' - ' + data.data_same.length)
                if (data != null && data.data_same && data.data_same.length > 0) {
                    
                    $colorSwatchList.html("").removeClass("loading");

                    const data_same = data.data_same;
                    let content = ''; // Buat konten HTML

                    data_same.forEach(function (el) {
                        const active = "";
                        const corrected_link = productCurrentUrl.split('?');
                        const link = `${corrected_link[0]}/products/${el.handle}?${corrected_link[1]}`;

                        content += `
                            <div class="color-swatch-item ${active}">
                                <a href="${link}" class="result-swatch-item">
                                <div class="swatch-img">
                                    <img src="${el.image}">  
                                </div>
                                </a>  
                            </div>
                        `;
                    });

                    $colorSwatchList.append(content); // Tambahkan konten ke DOM

                    if ($colorSwatchList.hasClass('slick-initialized')) {
                        $colorSwatchList.slick('unslick');
                    }

                    // if ($colorSwatchList.hasClass('slick-initialized') === false) {
                    $colorSwatchList.slick({
                        dots: false,
                        arrows: false,
                        infinite: true,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        autoplay: true,
                        autoplaySpeed: 2000
                    });
                    // }
                } else if (retryCount < maxRetries) {
                    // console.log(`Retrying API call for ${product_name}, attempt ${retryCount + 1}`);
                    await sleep(retryDelay); // Tunggu 1 detik sebelum retry
                    return callApi(product, retryCount + 1);
                //   console.log("tess load")
                    
                } else {
                    console.log(`Failed to load data for ${product_name} after ${maxRetries} attempts.`);
                    $colorSwatchList.html("<p></p>");
                  console.log("tess load")
                }
            } catch (err) {
                console.log(`Error occurred during API call for ${product_name}`, err);
                $colorSwatchList.html("").removeClass("loading");
                console.log(product_name + " not found")
              
            }
        }

        async function processQueueParallel(settingsArray) {
            const promises = settingsArray.map(product => callApi(product)); // Process all calls in parallel
            await Promise.all(promises);
            console.warn("color swatch completed.");
        }

        // Mulai memproses queue secara paralel
        if (!$(".template-product").length) {
            processQueueParallel(settingsArray);
        }
        else {
            // let process = setInterval(() => {
            //     let product_detail_swatch = localStorage.getItem("product_detail_swatch")
            //     if (product_detail_swatch) {
            //         localStorage.removeItem("product_detail_swatch")

            //         processQueueParallel(settingsArray);
            //         clearInterval(process);
            //     }
            // }, 1000);
        }
    }

    if($("#form-tracking").length) {
        function formatDateTime(dateTimeStr) {
            let dateObj = new Date(dateTimeStr.replace(" ", "T")); // Ubah ke format ISO agar bisa dikenali
        
            // Format tanggal dalam bahasa Inggris (contoh: "February 18, 2025")
            let formattedDate = dateObj.toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric"
            });
        
            // Format waktu dalam format 12 jam dengan AM/PM (contoh: "05:53 PM")
            let formattedTime = dateObj.toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true
            });
        
            return `On ${formattedDate} | ${formattedTime}`;
        }

        function getDayName(dateStr) {
            let [day, month, year] = dateStr.split("-"); // Pisahkan DD-MM-YYYY
            let dateObj = new Date(`${year}-${month}-${day}`); // Ubah ke format YYYY-MM-DD
            return dateObj.toLocaleDateString("en-US", { weekday: "long" }); // Ambil nama hari dalam bahasa Inggris
        }

        $('#form-tracking').submit(function(e){
            e.preventDefault();

            let url_shopify = Shopify.shop;
            console.log(url_shopify)
            let order_number = $("[name=order_number]").val();
            let email = $("[name=email]").val();

            $.ajax({
                type: "POST",
                url: `https://notify-general.shopify-plugin.devbdd.com/tracking_order`,
                data: {
                    "url_shopify": url_shopify,
                    "order_number": order_number,
                    "email": email
                },
                beforeSend: function() {
                    $('.submit-tracking').html('Please Wait...')
                    $('.submit-tracking').attr('disabled', 'disabled')
                },
                success: function(response) {
                    $('.submit-tracking').html('Track Order')
                    $('.submit-tracking').attr('disabled', false);
            
                    var result = JSON.parse(response);
                    let status = result.status;

                    if(status == 200){
                        let details = result.data;
                        let tanggal_pengiriman = new Date(details.cnote_date)
                        tanggal_pengiriman = tanggal_pengiriman.toISOString().replace("T", " ").split(".")[0]
                        let berat_paket = details.weight * 1
                        berat_paket = Math.round(berat_paket) + " kg";

                        let history = result.data.history;
                        var groupedHistory = history.reduce(function(acc, item) {
                            var dateParts = item.date.split(" ");  // Pisahkan tanggal dan waktu
                            var dateOnly = dateParts[0]; // Ambil hanya tanggal
                    
                            if (!acc[dateOnly]) {
                                acc[dateOnly] = [];
                            }
                    
                            acc[dateOnly].push({ time: dateParts[1], desc: item.desc, code: item.code });
                            return acc;
                        }, {});

                        let history_item = ``;
                        $.each(groupedHistory, function(date, items) {
                            let timeline = ``;
                            $.each(items, function(index, item) {
                                timeline += `
                                    <div class="entry">
                                        <span class="time">${item.time}</span>
                                        <p>${item.desc}</p>
                                    </div>
                                `;
                            });

                            history_item += `
                                <div class="timeline-item">
                                    <div class="date">${getDayName(date)}<br>
                                        <span>${date}</span>
                                    </div>
                                    <div class="line">
                                        <span class="circle"></span>
                                    </div>
                                    <div class="content">
                                        ${timeline}
                                    </div>
                                </div>
                            `;
                        });                        

                        let history_html = `
                            <div class="detail-summary">
                                <div class="detail-header">
                                    <div class="top-section">
                                        <div class="tracking-container">
                                            <div class="tracking-info">
                                                <p>Tracking No. <span id="${details.awb}" data-id="${details.awb}" class="tracking-number">${details.awb}</span>
                                                </p>
                                            </div>
                                            <div class="status-info">
                                                <h2 class="status-text">${details.status}</h2>
                                                <p class="status-date">${formatDateTime(tanggal_pengiriman)}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="detail-body">
                                    <div class="timeline">
                                        ${history_item}
                                    </div>
                                </div>
                            </div>
                        `;

                        $('.awb-history').html(history_html)
                    }
                    else{
                        $('.awb-history').html(result.message)
                    }
            
                    $('html, body').animate({
                        scrollTop: $(".awb-history").offset().top
                    }, 500);
                },
                error: function(response) {
                    alert('Something wrong, please refresh.')
                }
            });
        });
    }
})